// Module
var code = "<div class=\"restrict-width\" data-ui-view> <h1 data-translate>site.LIST_HEADER</h1> <p class=\"view-description\" data-translate>site.LIST_DESCRIPTION</p> <vngage-column-table data-columns=\"vm.tableColumns\" data-options=\"vm.tableOptions\" data-resource=\"vm.siteList\"> site.LIST_TITLE </vngage-column-table> </div> ";
// Exports
var _module_exports =code;;
var path = 'app/account/site/SiteListTemplate.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;